import React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import ClientesStatCard from "../components/ClientesStatCard";
import ClientesTable from "../components/ClientesTable";
import useEstadoClientes from "../hooks/useEstadoClientes";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "calc(100vh - 96px)",
    background: "#080f1f",
    color: "#f5f7fb",
    padding: theme.spacing(3),
  },
  header: {
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
    justifyContent: "space-between",
    marginBottom: theme.spacing(2.25),
  },
  title: {
    color: "#f5f7fb",
    fontSize: 19,
    fontWeight: 900,
  },
  statsGrid: {
    marginBottom: theme.spacing(3),
  },
}));

const ClientesView = () => {
  const classes = useStyles();
  const {
    error,
    loading,
    rows,
    stats,
    page,
    rowsPerPage,
    totalElements,
    onPageChange,
    onRowsPerPageChange,
  } = useEstadoClientes();

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography className={classes.title}>Gestion de Clientes</Typography>
      </div>

      <Grid container spacing={2} className={classes.statsGrid}>
        {stats.map((item) => (
          <Grid item xs={12} md={4} key={item.label}>
            <ClientesStatCard item={item} />
          </Grid>
        ))}
      </Grid>

      <ClientesTable
        error={error}
        loading={loading}
        rows={rows}
        totalElements={totalElements}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </div>
  );
};

export default ClientesView;
